import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const sanitizeFileName = ({ file }: { file: File }) => {
  const filename = `file_${file.lastModified}_${file.size}`;

  return new File([file], filename, { type: file.type });
};

export const convertToBase = ({
  imageUrl,
  networkId,
}: {
  imageUrl: string;
  networkId: number;
}) =>
  axios.get(
    Routes.convert_to_base_backoffice_network_uploads_path(networkId, {
      format: 'json',
      image_url: imageUrl,
      network_id: networkId,
    }),
  );

export const convertToFile = ({ imageString }) =>
  fetch(imageString)
    .then((res) => res.arrayBuffer())
    .then((buf) => new File([buf], 'file-from-base64', { type: 'image/jpeg' }));
